import { useMemo } from 'react';
import { useRecentMessage } from '@modules/channels/hooks/use-recent-message2';
import { ContactItem } from '../components/bulk-messaging/bulk-messaging.types';

const RECENT_CONTACTS_LIMIT = 5;

export const useBulkMessagingRecentContacts = (): ContactItem[] => {
  const recentMessage = useRecentMessage({ query: '' });

  return useMemo<ContactItem[]>(
    () =>
      (recentMessage.data ?? []).slice(0, RECENT_CONTACTS_LIMIT).map((item) => ({
        id: String(item.client?.id),
        name: item.name ?? 'Unknown',
        phoneNumber: item.client?.phoneNumber ?? '+1',
        countryName: 'Unknown',
        avatar: item.avatarUrl ?? undefined,
      })),
    [recentMessage.data]
  );
};
